<div class="modal-container" [class.cc-mobile]="isMobile">
  <div *ngIf="!isMobile" class="text-center">
    <div class="po" *ngIf="item.po_id !== null && !enableAsVirtual">PO: {{ po }}</div>
    <div class="container-id" *ngIf="item.po_id !== null || (enableAsVirtual && item.id !== null)">Container ID {{ item.id }}</div>
    <div class="container-id" *ngIf="item.po_id === null && !(enableAsVirtual && item.id !== null)">{{ enableAsVirtual ? 'Create New Virtual Container' : 'Create New Container' }}</div>
  </div>

  <!-- Mobile header + pill tabs -->
  <ng-container *ngIf="isMobile">
    <div class="cc-header">
      <div class="cc-title">
        <span class="material-icons cc-title-icon">web_asset</span>
        <span *ngIf="item.po_id !== null || (enableAsVirtual && item.id !== null)">Container ID {{ item.id }}</span>
        <span *ngIf="item.po_id === null && !(enableAsVirtual && item.id !== null)">{{ enableAsVirtual ? 'Create New Virtual Container' : 'Create New Container' }}</span>
      </div>
      <div class="cc-po" *ngIf="item.po_id !== null && !enableAsVirtual">PO# {{ po }}</div>
      <button type="button" class="cc-close-icon" aria-label="Close" (click)="close()">
        <span class="material-icons">close</span>
      </button>
    </div>
    <div class="cc-tabs">
      <ng-container *ngFor="let option of options">
        <button
          *ngIf="option.visibility"
          type="button"
          class="cc-tab"
          [class.active]="tab == option.tab"
          [disabled]="option.tab === 2 && item.id === null"
          [title]="option.tab === 2 && item.id === null ? 'Save the container first to add items' : ''"
          (click)="changeTab(option.tab, item.id)"
        >
          <span class="material-icons cc-tab-icon">{{ option.icon }}</span>
          <span *ngIf="option.colName !== 'Notes' && option.colName !== 'View Items'">{{ option.colName }}</span>
          <span *ngIf="option.colName === 'Notes'">Notes ({{ total_chats }})</span>
          <span *ngIf="option.colName === 'View Items'">Items ({{ totalItems }})</span>
        </button>
      </ng-container>
    </div>
  </ng-container>

  <nav *ngIf="!isMobile" class="nav nav-tabs d-flex mt-3 ml-3">
    <ng-container *ngFor="let option of options; let i = index">
      <div
        [attr.data-index]="i"
        class="flex-fill"
        *ngIf="option.visibility"
      >
        <div
          *ngIf="options[i].visibility"
          class="nav-item nav-link-h"
          [ngClass]="{ active: tab == option.tab, lasttab: option.tab === 4 }"
          (click)="changeTab(option.tab, item.id)"        
        >
          <i class="material-icons">{{ option.icon }}</i> <br />
          <p class="texto-tab" *ngIf="option.colName !== 'Notes' && option.colName !== 'View Items'">
            {{ option.colName }}
          </p>
          <p class="texto-tab" *ngIf="option.colName === 'Notes'">{{ option.colName }} ({{ total_chats }})</p>
          <p class="texto-tab" *ngIf="option.colName === 'View Items'">{{ option.colName }} ({{ totalItems }})</p>
        </div>
      </div>
    </ng-container>
  </nav>
  <br *ngIf="!isMobile">
  <div class="col-md-12">
    <div *ngIf="tab === 1">
      <form #f="ngForm">
        <div *ngIf="loading">
          <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i
          ><span class="sr-only">Loading...</span>
        </div>

        <div *ngIf="!loading">
          <div
            *ngIf="
              (item.po_id !== null && !enableAsVirtual) ||
              (enableAsVirtual && item.po_id === null)
            "
          >
            <div *ngIf="!enableAsVirtual">
              <div class="d-flex" [class.flex-column]="isMobile">
                <div class="form-group w-100 mr-3">
                  <mat-form-field [appearance]="isMobile ? 'outline' : 'fill'">
                    <mat-label>Item Type</mat-label>

                    <mat-select
                      name="itemtypeForm"
                      matNativeControl
                      [(ngModel)]="item.item"
                      placeholder="Item Type"
                      (selectionChange)="sumarPeso()"
                      [disabled]="!edit"
                      required
                    >
                      <mat-option
                        *ngFor="let container of containers"
                        [value]="container.name"
                      >
                        {{ container.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="form-group w-100 mr-3">
                  <mat-form-field [appearance]="isMobile ? 'outline' : 'fill'">
                    <mat-label>Stage</mat-label>

                    <mat-select
                      name="is_piForm"
                      matNativeControl
                      [(ngModel)]="item.is_pi"
                      placeholder="Stage"
                      [disabled]="lockStage"
                      (change)="massive = false; bulk_cant = 0"
                      required
                    >
                      <mat-option
                        *ngFor="let stage of stages"
                        [value]="stage.value"
                      >
                        {{ stage.viewValue }}
                      </mat-option>
                    </mat-select>

                    <button
                      mat-icon-button
                      matSuffix
                      class="lock-icon-btn"
                      tabindex="-1"
                      (click)="lockStage = !lockStage"
                      [attr.aria-label]="lockStage ? 'Locked' : 'Unlocked'"
                    >
                      <mat-icon class="lock-icon">{{ lockStage ? 'lock' : 'lock_open' }}</mat-icon>
                    </button>
                  </mat-form-field>
                </div>
                <div class="form-group w-100">
                  <mat-form-field class="example-full-width" [appearance]="isMobile ? 'outline' : 'fill'">
                    <mat-label>Total Weight (Lbs)</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0.00"
                      step="1"
                      class="currency"
                      placeholder="00.00"
                      name="totalWeightForm"
                      [(ngModel)]="item.weight"
                      (change)="sumarPeso()"
                      [disabled]="!edit"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="d-flex" [class.flex-column]="isMobile">
                <div class="form-group w-100 mr-3">
                  <mat-form-field class="example-full-width" [appearance]="isMobile ? 'outline' : 'fill'">
                    <mat-label>NET Weight (Lbs)</mat-label>
                    <input
                      matInput
                      type="number"
                      min="0.01"
                      step="0.01"
                      class="currency"
                      placeholder="00.00"
                      name="totalNetWeightForm"
                      [(ngModel)]="item.totalNetWeight"
                      readonly
                    />
                  </mat-form-field>
                </div>
                <div class="form-group w-100 mr-3">
                  <mat-form-field [appearance]="isMobile ? 'outline' : 'fill'">
                    <mat-label>Damages</mat-label>

                    <mat-select
                      name="damagesForm"
                      matNativeControl
                      [(ngModel)]="item.damages"
                      placeholder="Damages"
                      (change)="massive = false; bulk_cant = 0"
                      [disabled]="!edit"
                      required
                    >
                      <mat-option
                        *ngFor="let damage of damages"
                        [value]="damage.value"
                      >
                        {{ damage.viewValue }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="form-group w-100">
                  <mat-form-field [appearance]="isMobile ? 'outline' : 'fill'">
                    <mat-label>Type Of Equipment</mat-label>

                    <mat-select
                      name="typeEquipment"
                      matNativeControl
                      [(ngModel)]="item.typeEquipment"
                      placeholder="Type Of Equipment"
                    >
                      <mat-option
                        *ngFor="let item of typesofequipment"
                        [value]="item"
                      >
                        {{ item }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field *ngIf="item.typeEquipment === 'Custom'" class="example-full-width" [appearance]="isMobile ? 'outline' : 'fill'">
                    <mat-label>Custom Type</mat-label>
                    <input
                      matInput
                      type="text"
                      name="customTypeForm"
                      [(ngModel)]="item.customType"
                      placeholder="Enter custom type"
                      [disabled]="!edit"
                      required
                    />
                  </mat-form-field>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div style="margin-top: 10px">
                    <label *ngIf="loadingLocations"
                      >Location <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
                    ></label>

                    <app-filter-object
                      *ngIf="!loadingLocations"
                      [options]="locationsList"
                      placeholder="Locations"
                      [value]="item.internallocation_id"
                      (selectChange)="changeLocation($event)"
                      (valueChange)="onValueChange($event)"
                      [disabled]="item.pending !== 0">
                    >
                    </app-filter-object>
                    <div class="row">
                      <div class="col-md-6">
                        <mat-checkbox (change)="onCheckboxChange($event)"
                          >Show External Locations</mat-checkbox
                        >
                      </div>
                    </div>
                    <p class="disabled-location" *ngIf="!loadingLocations && item.pending !== 0"><i class="material-icons" style="margin-top: 5px; font-size: 16px; margin-right: 6px;">info_outline</i>This container can't be moved or marked as processed because this container it's inside a ticket.</p>
                  </div>
                </div>
              </div>

              <div *ngIf="item.linkTo !== null && locationsList.length && item.id === null && item.is_pi !== 1 && item.damages !== 'Yes'" class="row">
                <div class="col-3">
                  <mat-checkbox name="createamassive" [(ngModel)]="massive">Massive Creation</mat-checkbox>
                </div>
                <div *ngIf="massive" class="col-9">
                  <label>How many containers to create?</label>
                        <input type="number" class="form-control currency" name="cantcreate" [(ngModel)]="bulk_cant" (keypress)="mtds.onlyNumber($event)" />
                </div>
              </div>

            </div> <!--<div *ngIf="!enableAsVirtual"> -->
            <div *ngIf="enableAsVirtual" class="form-group">
              <label for="nameVirtual">Virtual Container Name</label>
              <i
                class="fa fa-lock"
                aria-hidden="true"
                data-toggle="tooltip"
                style="cursor: pointer; margin-top: 20px; margin-left: 10px"
                data-placement="top"
                title="Unlock Virtual Container"
                (click)="unlockNameVirtualFunction(0)"
                *ngIf="item.id !== null && !unlockNameVirtual"
              ></i>
              <i
                class="fa fa-unlock"
                aria-hidden="true"
                data-toggle="tooltip"
                style="cursor: pointer; margin-top: 20px; margin-left: 10px"
                data-placement="top"
                title="Lock Virtual Container"
                (click)="unlockNameVirtualFunction(1)"
                *ngIf="item.id !== null && unlockNameVirtual"
              ></i>
              <input
                type="text"
                name="nameVirtual"
                [(ngModel)]="item.nameVirtualContainer"
                class="form-control"
                required
                [readonly]="!unlockNameVirtual"
              />
          </div> <!--<div *ngIf="enableAsVirtual"> -->
          </div> <!--*ngIf=" (item.po_id !== null && !enableAsVirtual) || (enableAsVirtual && item.po_id === null)"-->
          <div *ngIf="item.po_id === null && !enableAsVirtual &&  data.poNumber == undefined">
            <select-filter
              plholder="Enter PO Number"
              type="po"
              [options]="poOptions"
              type="poFull"
              (changeOption)="selectPO($event)"
            ></select-filter>
          </div> <!--Fin *ngIf="item.po_id === null && !enableAsVirtual" -->
        </div> <!--Fin Loading -->
        <app-bulk-job-progress
          *ngIf="activeBulkLocationJobId"
          [jobId]="activeBulkLocationJobId"
          (done)="onBulkLocationJobDone($event)"
        ></app-bulk-job-progress>

        <ng-container *ngIf="isMobile">
          <button
            *ngIf="item.id !== null"
            type="button"
            class="gts-btn-primary-outline cc-photo-btn"
            (click)="addPhoto()"
          >
            <span class="gts-btn-icon-left">add_a_photo</span
            ><span class="gts-btn-text">Add Photo</span>
          </button>
          <div class="cc-footer">
            <button
              type="button"
              class="gts-btn-primary-outline cc-btn-cancel"
              (click)="close()"
            >
              <span class="gts-btn-icon-left">highlight_off</span
              ><span class="gts-btn-text">Cancel</span>
            </button>
            <button
              *ngIf="
                (item.id !== null && !enableAsVirtual) ||
                (item.id === null && !enableAsVirtual && item.po_id !== null) ||
                (item.id === null && enableAsVirtual)
              "
              type="button"
              class="gts-btn-primary"
              (click)="save()"
              [disabled]="saving || !f.valid || (item.internallocation_id === null && !enableAsVirtual)"
            >
              <span *ngIf="!saving" class="gts-btn-icon-left">save</span>
              <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
              <span class="gts-btn-text">Save Changes</span>
            </button>
          </div>
        </ng-container>

        <div *ngIf="!isMobile" class="d-flex justify-content-end">
          <button class="btn btn-primary" *ngIf="item.id !== null" (click)="addPhoto()">
            Add Photo
          </button>
          <button
            *ngIf="
              (item.id !== null && !enableAsVirtual) ||
              (item.id === null && !enableAsVirtual && item.po_id !== null) ||
              (item.id === null && enableAsVirtual)
            "
            (click)="save()"
            class="btn btn-success"
            [disabled]="saving || !f.valid || (item.internallocation_id === null && !enableAsVirtual)"
          >
            <!--<i *ngIf="!saving" class="fa fa-floppy-o" aria-hidden="true"></i>-->
            <i *ngIf="saving" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
            &nbsp; Save Changes
          </button>
        </div>
      </form>
    </div>
    <div *ngIf="tab === 2">
      <form #f2="ngForm">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="typeInventory">Add by</label>
              <select
                name="typeInventory"
                [(ngModel)]="nuevo.type"
                (change)="cleanValues()"
                class="form-control"
                required
              >
                <option value="" disabled>Please select an option</option>
                <option value="serialnumber">Serial Number</option>
                <option value="dashboardid">Dashboard ID</option>
                <option value="iqid">IQ ID</option>
                <option value="poline">Po Number & Line Item</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="bmd-label-floating">Value:</label>
              <div class="form-group">
                <textarea
                  name="nuevoValue"
                  #notes="ngModel"
                  [(ngModel)]="nuevo.value"
                  class="form-control"
                  rows="3"
                  required
                  (keydown)="onEnter($event)"
                ></textarea>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="itemsID.length > 0 || itemsAdd.length > 0" class="row d-flex justify-content-center">

          <!-- Cuadro izquierdo -->
          <div class="custom-box orange-box full-width-box">

            <!-- Cuadro izquierdo -->
            <p class="items-error">
              <i class="material-icons" style="font-size: 16px; color: #C19A0A">warning</i>
              Are you sure you want to move this item(s)?
            </p>

            <div class="items-error" *ngFor="let item of itemsID" [ngClass]="{ red: item.status === 0 }">
              Item {{ item.id_inventory }} {{ item.status === 0 ? 'is not found' : 'is inside container ' + item.id_weight_item }} {{ item.name_container }}
              <i class="material-icons" style="font-size: 16px; color: #FF0000; margin-left: >5px; cursor: pointer;" (click)="removeItemFromArray(item.id_inventory)">delete</i>
            </div>

            <!--<div
              style="font-weight: 900"
              class="alert alert-warning alert-dismissible fade show"
              role="alert"
              *ngIf="item.status !== 0 && item.status !== 1"
            >
              Item {{ item.id_inventory }} is unable to add it because is
              {{ item.status }}
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                (click)="removeItemFromArray(item.id_inventory)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>-->
 
          </div>
          <!-- Cuadro derecho -->
          <div class="custom-box green-box full-width-box">
            <p class="items-error">
              <i class="material-icons" style="font-size: 16px; color: #4CAF50;">check_box</i>
              List of items added successfully
            </p>
              
            <div class="items-error" *ngFor="let item of itemsAdd">
              Item {{ item.id_inventory }} was added to the container
              <i class="material-icons" style="font-size: 16px; color: #4CAF50; margin-left: >5px;">check</i>
            </div>

          </div>

          <!--

          <div class="col-md-12" *ngFor="let item of itemsID">
            <div
              style="font-weight: 900"
              class="alert alert-danger alert-dismissible fade show"
              role="alert"
              *ngIf="item.status === 0"
            >
              Item {{ item.id_inventory }} not found!
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                (click)="removeItemFromArray(item.id_inventory)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              style="font-weight: 900"
              class="alert alert-primary alert-dismissible fade show"
              role="alert"
              *ngIf="item.status === 1"
            >
              This item {{ item.id_inventory }} is inside container
              {{ item.id_weight_item }} {{ item.name_container }}
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                (click)="removeItemFromArray(item.id_inventory)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              style="font-weight: 900"
              class="alert alert-warning alert-dismissible fade show"
              role="alert"
              *ngIf="item.status !== 0 && item.status !== 1"
            >
              Item {{ item.id_inventory }} is unable to add it because is
              {{ item.status }}
              <button
                type="button"
                class="close"
                data-dismiss="alert"
                aria-label="Close"
                (click)="removeItemFromArray(item.id_inventory)"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="col-md-12" *ngIf="confirmMove">
            <div style="font-weight: 900" class="alert alert-info">
              Are you sure you want to move this item(s)?<br />

              <ul>
                <li *ngFor="let item of itemsID">
                  {{ item.id_inventory }}
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-6 text-center">
            <button
              type="button"
              class="btn btn-danger"
              (click)="cleanValues()"
            >
              Cancel
            </button>
          </div>
          <div class="col-md-6 text-center">
            <button
              type="button"
              class="btn btn-success"
              (click)="confirmChangeContainer()"
              [disabled]="saveConfirmMove"
            >
              <i *ngIf="!saveConfirmMove" class="fa fa-floppy-o" aria-hidden="true"></i>
              <i *ngIf="saveConfirmMove" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
              Confirm
            </button>
          </div>-->
        </div>
      </form>
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-danger"
          (click)="cleanValues()"
          [disabled]="((itemsID.length === 0 && itemsAdd.length === 0 ) && nuevo.value === '')"
        >
          Clean
        </button>
        &nbsp;&nbsp;
        <button
          type="button"
          class="btn btn-success"
          (click)="saveItem()"
          [disabled]="!f2.valid || savingItem"
        >
          <!--<i *ngIf="!savingItem" class="fa fa-floppy-o" aria-hidden="true"></i>-->
          <i *ngIf="savingItem" class="fa fa-circle-o-notch fa-spin fa-fw"></i>
          Save Changes
        </button>
      </div>
    </div>
    <div *ngIf="tab === 3">
      <mat-toolbar>
        <span class="text-toolbar">{{ bulk.length === 0 ? 'Everything' : bulk.length + ' items selected' }}</span>
        <button mat-icon-button title="Download" data-toggle="tooltip" data-placement="right" style="color: #000" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="material-icons">file_download</i>
        </button>
        <div class="dropdown-menu">
          <button 
            class="dropdown-item btn btn-outline-primary" 
            (click)="reportWithAttributes()">
              Report with Attributes (.xlsx)
          </button>
          <button
            class="dropdown-item btn btn-outline-primary"
            (click)="reportWithAttributesExtreme()"
          >
              Report with Attributes Extreme (.xlsx)
          </button>
        </div>
        <button mat-icon-button title="Attribute Items" data-toggle="tooltip" data-placement="right" style="color: #000" (click)="attributeMultipleItems()">
          <i class="material-icons">list_alt</i>
        </button>
        <button mat-icon-button title="Remove Items" data-toggle="tooltip" data-placement="right" style="color: #000" (click)="vaciarContainer(item.id)">
          <i class="material-icons">logout</i>
        </button>
        <button mat-icon-button title="Move Items" data-toggle="tooltip" data-placement="right" style="color: #000" (click)="moveItemsModal()">
          <i class="material-icons">swap_horiz</i>
        </button>
      </mat-toolbar>
 
      <div *ngIf="item.id !== null">
        <div *ngIf="loadingInventories" style="text-align: center">
          <br>
          <h2>
            <b
              ><i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
              Loading...</b
            >
          </h2>
        </div>
        <dinamic-table
          *ngIf="!loadingInventories"
          [id]="'inventoryTable'"
          [data]="inventories"
          [columnfilters]="filtros"
          [campoBusqueda]="campoBusqueda"
          [perPage]="itemsPorPagina"
          [page]="paginaActual"
          [total_items_count]="totalItems"
          [total_pages]="totalPaginas"
          [bulk]="bulk"
          (buscar)="getInventories($event,false)"
          (action_button)="actions($event)"
          (changeBulk)="changeBulk($event)"
        ></dinamic-table>
      </div>
    </div>
    <!--Notes-->
    <div *ngIf="tab === 4">
      <app-comments
        [id_phather]="item.id"
        type_chat="CONTAINERINVENTORY"
        type_notification="CITA_COMMENT"
        (receive_item_id)="receive_item_id($event)"
        [item]="item"
        (total_chats)="total_chats_func($event)"
        (saving_comment)="view_details = $event"
        [disabled]="enableAsVirtual
          ? !item.nameVirtualContainer
          : (item.item === '' || item.is_pi === null || item.weight === null || item.damages === '' || item.typeEquipment === '' || item.internallocation_id === null)"
      ></app-comments>
    </div> <!--Fin tab 4 - Notes-->
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="changeVirtualContainer"
  tabindex="-1"
  aria-labelledby="createModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="changeVirtualContainerLabel">
          <b>Move Virtual Container</b>
        </h2>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <span *ngIf="gettingContainers || loading"
              >Virtual Containers
              <i class="fa fa-circle-o-notch fa-spin fa-fw"></i
            ></span>

            <app-filter-object
              *ngIf="showContainerList"
              [options]="containerList"
              [value]="virtualContainerID"
              (selectChange)="changecontainer($event)"
              placeholder="Virtual Containers"
            >
            </app-filter-object>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button> -->
        <button
          type="button"
          class="btn btn-primary"
          (click)="saveChangeContainer()"
          [disabled]="virtualContainerID === 0"
        >
          Move Container
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="modalRemoveItems"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="exampleModalScrollableTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalScrollableTitle">
          Remove Items
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>
          <strong>Are these items going to be removed?</strong>
        </p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-success"
          (click)="removeItemsContainer()"
        >
          Yes
        </button>
        &nbsp; &nbsp;
        <button type="button" class="btn btn-danger" data-dismiss="modal">
          No
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="removeItemsModal"
  tabindex="-1"
  role="dialog"
  data-backdrop="static"
  aria-labelledby="exampleModalScrollableTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="exampleModalScrollableTitle">
          <!--<strong>Remove Items</strong>-->
        </h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
          <div class="alert alert-primary" role="alert">
            <h4 class="alert-heading"><strong>Remove Items</strong></h4>
            <hr>
            <p *ngIf="bulk.length > 0">Are you sure you want to remove this item from this container {{item.id}}?</p>
            <p *ngIf="bulk.length === 0">Are you sure you want to empty this container?</p>
          </div>
          <!--<strong *ngIf="bulk.length > 0">Are you sure you want to remove this item from this container {{item.id}}?</strong>
          <strong *ngIf="bulk.length === 0">Are you sure you want to empty this container?</strong>-->
      </div>
      <div class="modal-footer">
        <button
          *ngIf="bulk.length > 0"
          type="button"
          class="btn btn-success"
          (click)="removeItemsContainerModal()"
        >
          Yes
        </button>
        <button
          *ngIf="bulk.length === 0"
          type="button"
          class="btn btn-success"
          (click)="removeItemsContainerModal()"
        >
          Yes
        </button>
        &nbsp; &nbsp;
        <button type="button" class="btn btn-danger" data-dismiss="modal">
          No
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div
  class="modal fade"
  id="moveItemsModal"
  tabindex="-1"
  aria-labelledby="createModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="moveItemsLabel">
          <b>Move Items</b>
        </h2>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-12">
            <label>Container ID</label>
            <input
              type="text"
              name="idToMove"
              [(ngModel)]="idToMove"
              class="form-control"
            />
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <label class="d-block mb-2"><strong>Move options</strong></label>
            <div class="move-option-card" [class.move-option-active]="moveMode === 'all'" (click)="moveMode = 'all'">
              <span class="move-option-dot" [class.move-option-dot-active]="moveMode === 'all'"></span>
              <span>Move all items</span>
            </div>
            <div class="move-option-card mt-2"
                 [class.move-option-active]="moveMode === 'selected'"
                 [class.move-option-disabled]="bulk.length === 0"
                 (click)="bulk.length > 0 ? moveMode = 'selected' : null">
              <span class="move-option-dot" [class.move-option-dot-active]="moveMode === 'selected'"></span>
              <div class="move-option-content">
                <span>Move only selected items</span>
                <span *ngIf="bulk.length > 0" class="badge badge-primary ml-2">{{ bulk.length }} selected</span>
                <small *ngIf="bulk.length === 0" class="d-block text-muted mt-1">No items selected — check items in the list first</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        &nbsp;
        <button
          type="button"
          class="btn btn-primary"
          (click)="moveItems()"
          [disabled]="idToMove === '' || moving || (moveMode === 'selected' && bulk.length === 0)"
        >
          <span *ngIf="moving"><i class="fa fa-spinner fa-spin"></i> Moving...</span>
          <span *ngIf="!moving">Move Items</span>
        </button>
      </div>
    </div>
  </div>
</div>